import { useCallback, useState } from "react";
import { Severity } from "type";
import downloadWeeklyReplenishmentFormatApi from "../api/downloadWeeklyReplenishmentErrorApi";
import deleteWeeklyErrorCsv from "../api/deleteWeeklyErrorCsv";

/**
 * Custom hooks to use large CSV operations.
 * @param showAlert アラート表示
 */
export default function useLargeCsv(showAlert: (msg: string, severity?: Severity) => void) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [progress, setProgress] = useState<number | null>(null);

  const handleDownload = useCallback(async () => {
    setIsLoading(true);
    let csvSuccessFlag: boolean = false;
    try {
      await downloadWeeklyReplenishmentFormatApi((percent) => {
        setProgress(percent);
      });
      csvSuccessFlag = true;
      await deleteWeeklyErrorCsv();
      showAlert("週次補充エラーレポートCSVをダウンロードしました", "success");
      await new Promise((resolve) => {setTimeout(resolve, 3000)}); // ダウンロード完了後、3秒待ってから週次補充カード表示へ
      setProgress(null);
    } catch (error) {
      console.error(error);
      showAlert(csvSuccessFlag ? "エラーレポートデータの削除に失敗しました" : "エラーレポートCSVのダウンロードに失敗しました", "error");
    } finally {
      setIsLoading(false);
    }
  }, [showAlert]);

  return {
    handleDownload,
    isLoading,
    setIsLoading,
    progress,
  };
}
